<template>
  <div class="bar">
    <header class="bar-header">学业等级分布</header>
    <div class="bar-echarts" id="barEcharts"></div>
  </div>
</template>

<script>
export default {
  name: 'GradeBar',
  props: {
    levelList: {
      require: true,
      default: () => [],
    },
  },
  data() {
    return {
    };
  },
  mounted() {
    this.barEcharts();
  },
  watch: {
    levelList() {
      this.barEcharts();
    },
  },
  methods: {
    barEcharts() {
      const that = this;
      const chartDom = document.getElementById('barEcharts');
      const myChart = this.$echarts.init(chartDom);
      const option = {
        color: ['#D157F3', '#FE9B64', '#FFE356', '#12ADFF', '#39D6E1'],
        tooltip: { // 提示框
          trigger: 'axis',
          axisPointer: { // Use axis to trigger tooltip
            type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
          },
          formatter(params) {
            // 暂时不要header
            // const headerName = params.length && `<div style="text-align:center;">
            // ${params[0].name}</div>`;
            const customList = params.length && params.map((item) => {
              const dotColor = `<span style="display:inline-block;margin-right:5px;border-radius:
            10px;width:9px;height:9px;background-color:${item.color}"></span>`;
              return `${dotColor + item.seriesName}:${item.value || 0}%</br>`;
            });
            // return headerName + customList.join('');
            return customList.join('');
          },
        },
        legend: { // 头部提示
          data: ['未掌握(0~19%)', '掌握较弱(20~39%)', '掌握一般(40~59%)', '掌握较好(60~79%)', '掌握熟练(80~100%)'],
          padding: [10, 0, 0, 0],
          top: 10,
          left: '27.5%',
          icon: 'circle',
          itemGap: 20, // 设置间距
          textStyle: {
            color: '#ffffff', // 字体颜色
          },
        },
        grid: { // 整体位置调整
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: that.levelList.map((item) => item.grade),
          axisLabel: { // 字体修改
            show: true,
            textStyle: {
              color: '#C5C3DE',
            },
            interval: 0,
            rotate: 30,
          },
          axisLine: { // 不显示轴线
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          name: '平均掌握程度',
          nameTextStyle: { // name样式修改
            align: 'center',
            color: '#C5C3DE',
            padding: [0, 0, 12, -18],
          },
          axisLabel: {
            formatter: '{value} %',
            textStyle: {
              show: true,
              interval: 'auto',
              formatter: '{value} %',
              color: '#fff',
              fontSize: '12',
            },
          },
          max: 100,
          min: 0,
          splitLine: { // 网格线
            lineStyle: {
              type: 'dashed', // 设置网格线类型 dotted：虚线 solid:实线
              width: 1,
              color: 'rgba(255, 255, 255, 0.3)',
            },
            show: true, // 隐藏或显示
          },
        },
        series: [
          {
            name: '未掌握(0~19%)',
            type: 'bar',
            stack: 'total',
            label: { // 显示数值
              show: true,
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}%',
              },
            },
            // emphasis: {
            //   focus: 'series',
            // }, 鼠标hover时只显示当前未掌握的值
            barWidth: '22%',
            data: that.levelList.map((item) => (Number(item.level_1) === 0 ? '' : item.level_1)),
            itemStyle: {
              normal: {
                color: '#D157F3',
              },
            },
          },
          {
            name: '掌握较弱(20~39%)',
            type: 'bar',
            stack: 'total',
            barWidth: '22%',
            label: {
              show: true,
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}%',
              },
            },
            data: that.levelList.map((item) => (Number(item.level_2) === 0 ? '' : item.level_2)),
            itemStyle: {
              normal: {
                color: '#FE9B64',
              },
            },
          },
          {
            name: '掌握一般(40~59%)',
            type: 'bar',
            stack: 'total',
            barWidth: '22%',
            label: {
              show: true,
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}%',
              },
            },
            data: that.levelList.map((item) => (Number(item.level_3) === 0 ? '' : item.level_3)),
            itemStyle: {
              normal: {
                color: '#FFE356',
              },
            },
          },
          {
            name: '掌握较好(60~79%)',
            type: 'bar',
            stack: 'total',
            barWidth: '22%',
            label: {
              show: true,
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}%',
              },
            },
            data: that.levelList.map((item) => (Number(item.level_4) === 0 ? '' : item.level_4)),
            itemStyle: {
              normal: {
                color: '#12ADFF',
              },
            },
          },
          {
            name: '掌握熟练(80~100%)',
            type: 'bar',
            stack: 'total',
            barWidth: '22%',
            label: {
              show: true,
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}%',
              },
            },
            data: that.levelList.map((item) => (Number(item.level_5) === 0 ? '' : item.level_5)),
            itemStyle: {
              normal: {
                color: '#39D6E1',
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.bar {
  &-header {
        position: relative;
        font-size: 28px;
        font-weight: 500;
        text-indent: 1em;
        color: #E3E2FF;
        margin: 25px 0 30px 0;
        &::before {
          content: '';
          position: absolute;
          width: 27px;
          height: 27px;
          top: 9px;
          left: -8px;
          background: url('../../images/cockpit-icon.png') no-repeat center / contain;
        }
      }
  &-echarts {
    width: 1039px;
    height: 446px;
    background: linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    border-radius: 8px;
    // opacity: 0.38;
  }
}
</style>
